<template>
  <v-card :disabled="disabled" width="100%" class="kim-card hover" dark :color="getStatusColor(appointment.event_status_id)" @click="$emit('click')">
    <v-card-title class="pa-2">
      <v-avatar size="30">
        <slot name="client:avatar" :appointment="appointment" :client="appointment.client || null" />
      </v-avatar>
      <div class="text-truncate body-1 ml-1 client-name">
        <slot name="client:name" :appointment="appointment" :client="appointment.client || null"/>
      </div>
      <v-spacer></v-spacer>
      <span class="time">
        <v-chip dark outlined>
          <v-icon class="mr-1">mdi-clock</v-icon>
          {{appointment.time}}
        </v-chip>
      </span>
    </v-card-title>
    <v-divider/>
    <v-card-subtitle class="pa-1 caption pl-2 text-truncate" >
        <slot name="details" :appointment="appointment" />
    </v-card-subtitle>

  </v-card>
</template>

<script>
  import {getFakeAvatar} from "@/utils/Common";
  import {getStatusColor} from "@/utils/ScheduleEvent";

  export default {
    name: "ClientAttentionCard",
    props: {
      disabled: {
        type: Boolean,
        default: false,
      },
      appointment: {
        type: Object,
        required: true
      }
    },
    methods:{
      getStatusColor,
    },
    computed:{
      client(){
        const vm = this
        const {
          first_name,
          last_name,
          gender,
          avatar,
        } = vm.appointment.client

        return {
          first_name,
          last_name,
          avatar: avatar || getFakeAvatar(gender),
        }

      }
    }
  }
</script>

<style scoped>

  .client-name{
    width: 120px;
    display: inline-block;
  }

  .time{
    display: inline-block;
  }

</style>
